import { ITabConfig } from '../interface/ITab';
import Depth3Tab from './feature/DefaultTab/Depth3Tab';
import DepthTabLayer from './feature/CustomTab/DepthTabLayer';

/**
 * @alias Tab
 * @category tab
 * @example
 * const tabConfig = {...}
 * if (window.ncui && window.ncui.Tab) {
 *    new window.ncui.tab(tabConfig);
 * }
 */
export default class Index {
    constructor(_config?: ITabConfig) {
        // console.log('-------Tab START-------');
        if (_config && Object.keys(_config).length !== 0)
            new DepthTabLayer(_config);
        else new Depth3Tab();
    }
} // end of class
